import { SharingDraft } from '@/types';
import { getRequest } from './methods/getRequest';
import { requestToJSON } from './methods/requestToJSON';

export const fetchTemplate = (templateId: string) =>
  requestToJSON<SharingDraft>(getRequest(`/api/templates/${templateId}/`));
